module.exports = __webpack_public_path__ + "img/empty-order.00a1c8c6.svg";